import * as React from "react";
import styles from "../styles/components/numberInput.module.scss";
import PropTypes from "prop-types";

const NumberInput = props => {
    const { error, submitFailed, touched, valid, required } = props.meta;
    const hasError = touched && (!!error || !valid);
    const disabledStyle = props.disabled ? styles.__disabled : '';
    return (
        <section
            className={styles.__outer}
        >
            {props.label &&
                <label className={styles.__field__label} >
                    {props.label}
                </label>
            }
            <section id={props.id} className={[styles.__bound, hasError ? styles.__hasError : '', disabledStyle].join(" ")}>
                <input
                    {...props.input}
                    className={styles.__field}
                    required={required}
                    min={0}
                    type="number"
                    placeholder={props.input_placeholder}
                    disabled={props.disabled}
                />
            </section>
            {touched && !valid && (<label className={styles.__err_helper}>{error}</label>)}

            {submitFailed && error && (
                <label className={styles.__err_helper}>{error}</label>
            )}
            {props.children}
        </section>
    );
};

NumberInput.propTypes = {
    disabled: PropTypes.bool,
    input_placeholder: PropTypes.string,
    icon: PropTypes.string,
    withIcon: PropTypes.bool,
    meta: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    id: PropTypes.string,
    children: PropTypes.func,
    showTooltip: PropTypes.bool
};

export default NumberInput;
